import { useMemo } from "react";
import { useSelector } from "react-redux";
import { LOAN_STATUS_LABEL_ALL_ACTIVE } from "../../constants/loanPipeline/LOAN_STATUS_LABEL_ALL_ACTIVE";
import { LOAN_STATUS_LABEL_ALL_CLOSED_LOANS } from "../../constants/loanPipeline/LOAN_STATUS_LABEL_ALL_CLOSED_LOANS";
import { LOAN_STATUS_LABEL_ALL_INACTIVE_LOANS } from "../../constants/loanPipeline/LOAN_STATUS_LABEL_ALL_INACTIVE_LOANS";
import { size } from "lodash";
import { LOAN_PIPELINE_FILTER_LABEL_ALL } from "../../constants/loanPipeline/LOAN_PIPELINE_FILTER_LABEL_ALL";

export const useLoanPipelineScreenHook = (pipelineFilter) => {
  const loanPipeline = useSelector((state) => state.loanPipeline);
  const loanPipelineList = useMemo(
    () => [
      LOAN_PIPELINE_FILTER_LABEL_ALL,
      "Borrower Portal Scenarios",
      "Scenario",
      "Underwriting",
      "Commercial",
    ],
    []
  );

  const loanStatusListActiveLoans = useMemo(() => {
    return [
      // LOAN_STATUS_LABEL_ALL_ACTIVE,
      "Prospect",
      "Terms Accepted",
      "Processing",
      "Appraisal Ordered",
      "Appraisal In",
      "Underwriting",
      "Final Review",
      "Clear To Close",
    ];
  }, []);

  const loanStatusListClosedLoans = useMemo(() => {
    return [
      LOAN_STATUS_LABEL_ALL_CLOSED_LOANS,
      "Closed",
      "Closed w/ Post Closing Conditions",
      "Loan Sold",
    ];
  }, []);

  const loanStatusListInactiveLoans = useMemo(() => {
    return [LOAN_STATUS_LABEL_ALL_INACTIVE_LOANS, "Inactive", "Dead"];
  }, []);

  const getPipelineStatusLabelWithCount = (pipeline, statusList, status) => {
    if (status === LOAN_STATUS_LABEL_ALL_ACTIVE) {
      const count = size(
        pipeline?.filter((loan) => statusList.includes(loan?.loanStatus))
      );
      return `${status} (${count})`;
    }
    const count = size(pipeline?.filter((loan) => loan?.loanStatus === status));
    return `${status} (${count})`;
  };
  return {
    loanPipeline,
    loanPipelineList,
    loanStatusListActiveLoans,
    loanStatusListClosedLoans,
    loanStatusListInactiveLoans,
  };
};
